// src/utils/image.js
// Robust fallback
export const FALLBACK_IMG =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="600" height="400">
    <rect width="100%" height="100%" fill="#F2F2F2"/>
    <text x="50%" y="50%" font-family="Arial" font-size="22" text-anchor="middle" fill="#999">No image</text>
  </svg>`);

// Prefer media[], then images[], then image
export function firstProductImage(p) {
  const candidates = [
    ...(Array.isArray(p?.media) ? p.media : []),
    ...(Array.isArray(p?.images) ? p.images : []),
    p?.image,
  ].filter(Boolean);

  const src = candidates.find(Boolean);
  if (!src) return FALLBACK_IMG;

  // guard against placeholders/bad urls
  const bad = /placeholder\.com/i.test(src) || src === 'about:blank' || src === 'blob:';
  return bad ? FALLBACK_IMG : src;
}
